import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { SharedModule } from '../shared/shared.module';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { IntuitiveComponent } from './intuitive/intuitive.component';
import { TIntuitiveComponent } from './t-intuitive/t-intuitive.component';
import { DistancesComponent } from './distances/distances.component';
import { TDistancesComponent } from './t-distances/t-distances.component';
import { ArrayLengthNotSmallerDirective } from './array-length-not-smaller.directive';
import { ArrayElementsEqualLengthDirective } from './array-elements-equal-length.directive';
import { MinimalDistanceDirective } from './minimal-distance.directive';
import { LengthDirective } from './length.directive';
import { CreateCodesComponent } from './create-codes/create-codes.component';
import { TCreateCodesComponent } from './t-create-codes/t-create-codes.component';
import { CtComputeBitsComponent } from './ct-compute-bits/ct-compute-bits.component';
import { TCtComputeBitsComponent } from './t-ct-compute-bits/t-ct-compute-bits.component';

import { SelfcorrectingService } from './selfcorrecting.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReverseBitComponent } from './reverse-bit/reverse-bit.component';
import { TReverseBitComponent } from './t-reverse-bit/t-reverse-bit.component';
import { ModuloComponent } from './modulo/modulo.component';
import { TModuloComponent } from './t-modulo/t-modulo.component';
import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';

import {PlaygroundComponent } from './playground/playground.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    SharedModule
  ], providers: [TopicService,
    LanguageProvider,
    SelfcorrectingService,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [ExercisesComponent,
    TopicComponent,
    TExercisesComponent,
    TAllExercisesComponent,
    ExamComponent,
    EvaluationComponent,
    OpenQuestionComponent,
    TOpenQuestionComponent,
    TExamComponent,
    TAllExamsComponent,
    MultipleChoiceComponent,
    TMultipleChoiceComponent, IntuitiveComponent, TIntuitiveComponent, DistancesComponent, TDistancesComponent, ArrayLengthNotSmallerDirective, ArrayElementsEqualLengthDirective, MinimalDistanceDirective, CreateCodesComponent, TCreateCodesComponent, CtComputeBitsComponent, TCtComputeBitsComponent, LengthDirective, ReverseBitComponent, TReverseBitComponent, ModuloComponent, TModuloComponent, ExampleComponent, TExampleComponent, PlaygroundComponent]
})
export class SelfcorrectingModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}
